export default __webpack_public_path__ + "static/media/tokenmetricMb.31b64e44.png";